// src/utils/CrearItemServicio.jsx

// Agregamos "export" al inicio
export const CrearItemServicio = ({
  codigo,
  tipo_servicio,
  tipo_plan,
  descripcion,
  modalidad_pago,
  metodo_pago,
  numero_cuotas,
  monto_por_cuota,
  precio_plan,
  detalles_adicionales = {},
}) => {
  return {
    codigo,
    tipo_servicio,
    tipo_plan,
    descripcion,
    modalidad_pago,
    metodo_pago,
    numero_cuotas,
    monto_por_cuota,
    precio_plan,
    detalles_adicionales,
  };
};